import { CategoryDetails } from 'store/api/event/types';
import { formatDate, formatCalendarDate } from 'utils/date';

// An expense's payment date is a calendar day stored at 00:00 UTC: show that
// day in every timezone (it showed a day early west of UTC). Other sources
// keep their own date handling.
export const formatRowDate = (row: Pick<CategoryDetails, 'date' | 'source'>) =>
  row.source === 'expense'
    ? formatCalendarDate(row.date)
    : formatDate(row.date);
